import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import dayjs from "dayjs";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import usePopOver from "@/hooks/use-popover";
import { ICampaignStatistics } from "@/interfaces/campaign-statistics.interface";
import { StatisticsPageMessages } from "@/messages/campaigns/statistics/statistics-page.messages";

import { CampaignPopover } from "../Popover";

interface Props {
  campaign: ICampaignStatistics;
  index: number;
  messages: StatisticsPageMessages;
  campaignId: string;
}

export function CampaignTableRow({ campaign, index, messages }: Props) {
  const popover = usePopOver<ICampaignStatistics>();
  const { openPopover, anchorEl, closePopover, isOpen, selected } = popover;

  return (
    <TableRow index={index} key={index}>
      <TableCell>{dayjs(campaign.scheduleDate).format("DD/MM/YYYY HH:mm") || "-"}</TableCell>
      <TableCell align="center">{campaign.sent}</TableCell>
      <TableCell align="center">{campaign.delivered}</TableCell>
      <TableCell align="center">{campaign.read}</TableCell>
      <TableCell align="center">{campaign.clicked}</TableCell>
      <TableCell align="center">{campaign.failed}</TableCell>
      <TableCell align="center">
        <IconButton onClick={(e) => openPopover(e, campaign)}>
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <CampaignPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
